module.exports = __webpack_public_path__ + "img/f-hk.248afe69.png";